import * as React from 'react';
import {RouteComponentProps} from "react-router-dom";
import {PluginTemplates} from "../../../../../utils/PluginTemplates";
import {
    FalconNavigatorHeader,
    ICustomerPortalService,
    Policy,
    Types,
    resourcesHelper,
    CLAIM_TYPE_OTHER,
    POLICY_STATUS_MTC,
    Renewal,
    PolicyPropertyEnum,
    PolicyProperty,
} from "@falcon/services";
import {setSessionStorage,} from "../../../../../CommonFunctions";
import {lazyInject} from "@athena-portal/core";
import {Overlay} from "@athena-portal/components";
import FalconFooter from "../../../../../components/navigation/FalconFooter";
import FalconHeader from "../../../../../components/navigation/FalconHeader";
import {Types as JourneyCoreTypeDefs, ILookupService} from "@athena-portal/plugin-journey";
import {ButtonLink} from "../../../../../components/navigation/ButtonLink";
import * as moment from "moment";
import {AnnualHomeDocumentListModal} from "@falcon/plugin-falcon-journey";
import {HomePolicySummary} from "./HomePolicySummary";

interface IPageParams {
    policyNumber: string;
}

export interface IProps extends RouteComponentProps<IPageParams> {
}

export interface IState {
    policy?: Policy;
    renewalProposal?: Renewal;
    renewalEnabled: boolean;
}

export class HomePolicySummaryPage extends React.Component<IProps, IState> {
    protected pluginTemplates = new PluginTemplates();

    @lazyInject(Types.CustomerPortalService)
    protected customerPortalService: ICustomerPortalService;

    @lazyInject(JourneyCoreTypeDefs.LookupService)
    protected lookupService: ILookupService;

    constructor(props: IProps) {
        super(props);

        this.state = {
            renewalEnabled: false
        }

    }

    public componentDidMount(): void {
        this.pluginTemplates.setPageTitle("Policy summary");
        this.customerPortalService
            .getPolicy(this.props.match.params.policyNumber)
            .subscribe((policy: Policy) => {
                this.setState({
                    policy
                })
            }
        );

        this.customerPortalService.getRenewalProposal(this.props.match.params.policyNumber).subscribe((renewalProposal: Renewal) => {
            this.setState({renewalProposal})
        });

        this.customerPortalService.getPolicyPropertyByPropertyKey(this.props.match.params.policyNumber, PolicyPropertyEnum.PERFORM_RENEWAL).subscribe(
            (property: PolicyProperty) => {
                this.setState({
                    renewalEnabled: property.value === "true"
                });
            }
        );
    }

    public render(): React.ReactNode {
        const backLinkUrl: string = `/dashboard/annualHome/${this.props.match.params.policyNumber}`;
        const claimsLink = this.state.policy?.interaction?.annualHomeFixedAddons?.homeEmergency
            ? `/dashboard/annualHome/${this.props.match.params.policyNumber}/claims/new`
            : `/dashboard/annualHome/${this.props.match.params.policyNumber}/claims/details`;
        if (!this.state.policy?.interaction?.annualHomeFixedAddons?.homeEmergency) {
            setSessionStorage("claim", CLAIM_TYPE_OTHER);
        }

        if (!this.state.policy) {
            return <Overlay show={true}/>
        } else {
            const policy: Policy = this.state.policy;
            const policyStarted = policy && policy.status !== POLICY_STATUS_MTC && moment().isAfter(moment(policy.startDate));
            return (
                <>
                    <FalconHeader/>
                    <div className="page-contents home-summary-page">
                        <FalconNavigatorHeader back={backLinkUrl} title="Policy summary"/>
                        {this.renderPolicyNumber()}
                        <div className="section-panel your-cover-panel padding-top-bot-50">
                            <img className="main-icon policy-icon"
                                 src={`/${resourcesHelper.THEME}/img/policy-summary.png`} alt="Policy summary icon"/>
                            <HomePolicySummary policyNumber={this.props.match.params.policyNumber} policy={policy} editAddress={true}/>
                        </div>
                        <AnnualHomeDocumentListModal
                            coverTier={policy.interaction.coverTier}
                            policyDate={new Date(policy.startDate)}
                            withTitle={true}
                            annualHomeFixedAddons={policy?.interaction.annualHomeFixedAddons}
                        />
                        {this.renderCancelPolicyButton(policy?.status === POLICY_STATUS_MTC)}
                        {policyStarted && <ButtonLink
                            primaryNoArrow={true}
                            className="make-a-claim"
                            to={claimsLink}>
                            Make a claim
                        </ButtonLink>}
                        {this.pluginTemplates.renderBackLink("Back", false, backLinkUrl)}
                    </div>
                    <FalconFooter/>
                </>
            )
        }
    }

    public renderPolicyNumber(): React.JSX.Element {
        return (
            <div className="page-heading-white">
                <span className="font-weight-light">Policy no: </span>
                {this.props.match.params.policyNumber}
            </div>
        );
    }

    public renderCancelPolicyButton(isDisabled: boolean): React.JSX.Element {
        if (this.state.renewalProposal && this.state.renewalEnabled) {
            return (
                <ButtonLink
                    to={`/dashboard/home/cancel/${this.props.match.params.policyNumber}`}
                    routeState={{
                        mtcJourneyUrl: `/journey/init/product/AnnualHomeInsurance/process/mtc/presetPage/${this.state.policy?.interaction?._id}`,
                        renewalCancellationUrl: `/journey/show/product/AnnualHomeInsurance/process/renewal/cancellationPresetPage/${this.state.renewalProposal._id}`,
                        pageTitle: "Cancel home policy",
                        questionTitle: "When would you like your home policy to end?"
                    }}
                    disabled={isDisabled}
                >
                    Cancel policy
                </ButtonLink>
            )
        } else {
            return (
                <ButtonLink to={`/journey/init/product/AnnualHomeInsurance/process/mtc/presetPage/${this.state.policy?.interaction._id}`} disabled={isDisabled}>
                    Cancel policy
                </ButtonLink>
            )
        }
    }
}



// WEBPACK FOOTER //
// ./src/pages/dashboard/annual/home/policySummary/HomePolicySummaryPage.tsx